__webpack_public_path__=(window['__webpack_public_path__'] + '////assets/plugin-web-new-home-page/').replace(/[/]{3,}/g, "/");